// @flow
import {
  SERVER_ADDRESS,
  fetchGet,
  fetchPost,
} from '../util/actionsUtil';

export const FETCH_DRUG_LIST_LOADING = 'FETCH_DRUG_LIST_LOADING';
export const FETCH_DRUG_LIST_SUCCESS = 'FETCH_DRUG_LIST_SUCCESS';
export const FETCH_DRUG_LIST_ERROR = 'FETCH_DRUG_LIST_ERROR';

// dispatch LOADING action only on initial pharmacy load (PharmacyTemplate.jsx)
export function fetchDrugListInitial() {
  return ((dispatch: Function) => {
    fetchGet(`${SERVER_ADDRESS}/pharmacy/drugList`,
      (data) => {
        dispatch({
          type: FETCH_DRUG_LIST_SUCCESS,
          data,
        });
      },
      (error) => {
        dispatch({
          type: FETCH_DRUG_LIST_ERROR,
          error: error.message,
        });
      });

    dispatch({
      type: FETCH_DRUG_LIST_LOADING,
    });
  });
}

export function fetchDrugList() {
  return ((dispatch: Function) => {
    fetchGet(`${SERVER_ADDRESS}/pharmacy/drugList`,
      (data) => {
        dispatch({
          type: FETCH_DRUG_LIST_SUCCESS,
          data,
        });
      },
      (error) => {
        dispatch({
          type: FETCH_DRUG_LIST_ERROR,
          error: error.message,
        });
      });
  });
}

export const FETCH_DISPENSARY_SUCCESS = 'FETCH_DISPENSARY_SUCCESS';
export const FETCH_DISPENSARY_ERROR = 'FETCH_DISPENSARY_ERROR';

export function fetchDispensaryHistory() {
  return ((dispatch: Function) => {
    fetchGet(`${SERVER_ADDRESS}/pharmacy/dispensaryHistory`,
      (data) => {
        dispatch({
          type: FETCH_DISPENSARY_SUCCESS,
          data,
        });
      },
      (error) => {
        dispatch({
          type: FETCH_DISPENSARY_ERROR,
          error: error.message,
        });
      });
  });
}


export const FETCH_TRANSACTIONS_SUCCESS = 'FETCH_TRANSACTIONS_SUCCESS';
export const FETCH_TRANSACTIONS_ERROR = 'FETCH_TRANSACTIONS_ERROR';

export function fetchTransactionHistory() {
  return ((dispatch: Function) => {
    fetchGet(`${SERVER_ADDRESS}/pharmacy/transactionHistory`,
      (data) => {
        dispatch({
          type: FETCH_TRANSACTIONS_SUCCESS,
          data,
        });
      },
      (error) => {
        dispatch({
          type: FETCH_TRANSACTIONS_ERROR,
          error: error.message,
        });
      });
  });
}

export const ADD_DRUG_LOADING = 'ADD_DRUG_LOADING';
export const ADD_DRUG_SUCCESS = 'ADD_DRUG_SUCCESS';
export const ADD_DRUG_ERROR = 'ADD_DRUG_ERROR';

export function addDrug(drug: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/pharmacy/addDrug`, {
        ...drug,
      },
      (data) => {
        dispatch({
          type: ADD_DRUG_SUCCESS,
          data,
        });
        dispatch(fetchDrugList());
      },
      (error) => {
        dispatch({
          type: ADD_DRUG_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: ADD_DRUG_LOADING,
    });
  });
}

export const DELETE_DRUG_LOADING = 'DELETE_DRUG_LOADING';
export const DELETE_DRUG_SUCCESS = 'DELETE_DRUG_SUCCESS';
export const DELETE_DRUG_ERROR = 'DELETE_DRUG_ERROR';

export function deleteDrug(drugId: string, editor: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/pharmacy/deleteDrug`, {
        drugId,
        editor,
      },
      (data) => {
        dispatch({
          type: DELETE_DRUG_SUCCESS,
          data,
        });
        dispatch(fetchDrugList());
      },
      (error) => {
        dispatch({
          type: DELETE_DRUG_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: DELETE_DRUG_LOADING,
    });
  });
}

export const ARCHIVE_DRUG_LOADING = 'ARCHIVE_DRUG_LOADING';
export const ARCHIVE_DRUG_SUCCESS = 'ARCHIVE_DRUG_SUCCESS';
export const ARCHIVE_DRUG_ERROR = 'ARCHIVE_DRUG_ERROR';

export function archiveDrug(drugId: string, editor: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/pharmacy/archiveDrug`, {
        drugId,
        editor,
      },
      (data) => {
        dispatch({
          type: ARCHIVE_DRUG_SUCCESS,
          data,
        });
        dispatch(fetchDrugList());
      },
      (error) => {
        dispatch({
          type: ARCHIVE_DRUG_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: ARCHIVE_DRUG_LOADING,
    });
  });
}

export const RECOVER_DRUG_LOADING = 'RECOVER_DRUG_LOADING';
export const RECOVER_DRUG_SUCCESS = 'RECOVER_DRUG_SUCCESS';
export const RECOVER_DRUG_ERROR = 'RECOVER_DRUG_ERROR';

export function recoverDrug(drugId: string, editor: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/pharmacy/recoverDrug`, {
        drugId,
        editor,
      },
      (data) => {
        dispatch({
          type: RECOVER_DRUG_SUCCESS,
          data,
        });
        dispatch(fetchDrugList());
      },
      (error) => {
        dispatch({
          type: RECOVER_DRUG_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: RECOVER_DRUG_LOADING,
    });
  });
}

export const UPDATE_DRUG_LOADING = 'UPDATE_DRUG_LOADING';
export const UPDATE_DRUG_SUCCESS = 'UPDATE_DRUG_SUCCESS';
export const UPDATE_DRUG_ERROR = 'UPDATE_DRUG_ERROR';

export function updateDrug(drug: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/pharmacy/updateDrug`, {
        ...drug,
      },
      (data) => {
        dispatch({
          type: UPDATE_DRUG_SUCCESS,
          data,
        });
        dispatch(fetchDrugList());
      },
      (error) => {
        dispatch({
          type: UPDATE_DRUG_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_DRUG_LOADING,
    });
  });
}

export const FETCH_DRUG_WITH_ID_LOADING = 'FETCH_DRUG_WITH_ID_LOADING';
export const FETCH_DRUG_WITH_ID_SUCCESS = 'FETCH_DRUG_WITH_ID_SUCCESS';
export const FETCH_DRUG_WITH_ID_ERROR = 'FETCH_DRUG_WITH_ID_ERROR';

export function fetchDrugWithId(drugId: string) {
  return ((dispatch: Function) => {
    fetchGet(`${SERVER_ADDRESS}/pharmacy/drug/${drugId}`,
      (data) => {
        dispatch({
          type: FETCH_DRUG_WITH_ID_SUCCESS,
          data: {
            ...data,
            drugId,
          },
        });
      },
      (error) => {
        dispatch({
          type: FETCH_DRUG_WITH_ID_ERROR,
          error: error.message,
        });
      });

    dispatch({
      type: FETCH_DRUG_WITH_ID_LOADING,
    });
  });
}

export const ADD_HISTORY_LOADING = 'ADD_HISTORY_LOADING';
export const ADD_HISTORY_SUCCESS = 'ADD_HISTORY_SUCCESS';
export const ADD_HISTORY_ERROR = 'ADD_HISTORY_ERROR';

export function addHistory(drugId: string, history: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/pharmacy/addHistory`, {
        drugId,
        ...history,
        quantityIn: history.quantityIn ? history.quantityIn : 0,
        quantityOut: history.quantityOut ? history.quantityOut : 0,
      },
      (data) => {
        dispatch({
          type: ADD_HISTORY_SUCCESS,
          data,
        });
        dispatch(fetchDrugList());
      },
      (error) => {
        dispatch({
          type: ADD_HISTORY_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: ADD_HISTORY_LOADING,
    });
  });
}

export const DELETE_HISTORY_LOADING = 'DELETE_HISTORY_LOADING';
export const DELETE_HISTORY_SUCCESS = 'DELETE_HISTORY_SUCCESS';
export const DELETE_HISTORY_ERROR = 'DELETE_HISTORY_ERROR';

export function deleteHistory(drugId: string, historyId: string, editor: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/pharmacy/deleteHistory`, {
        drugId,
        historyId,
        editor,
      },
      (data) => {
        dispatch({
          type: DELETE_HISTORY_SUCCESS,
          data,
        });
        dispatch(fetchDrugList());
      },
      (error) => {
        dispatch({
          type: DELETE_HISTORY_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: DELETE_HISTORY_LOADING,
    });
  });
}

export const UPDATE_HISTORY_LOADING = 'UPDATE_HISTORY_LOADING';
export const UPDATE_HISTORY_SUCCESS = 'UPDATE_HISTORY_SUCCESS';
export const UPDATE_HISTORY_ERROR = 'UPDATE_HISTORY_ERROR';

export function updateHistory(drugId: string, history: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/pharmacy/updateHistory`, {
        drugId,
        ...history,
        quantityIn: history.quantityIn ? history.quantityIn : 0,
        quantityOut: history.quantityOut ? history.quantityOut : 0,
      },
      (data) => {
        dispatch({
          type: UPDATE_HISTORY_SUCCESS,
          data,
        });
        dispatch(fetchDrugList());
      },
      (error) => {
        dispatch({
          type: UPDATE_HISTORY_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_HISTORY_LOADING,
    });
  });
}



// WEBPACK FOOTER //
// ./client/src/actions/pharmacyActions.js